// ══════════════════════════════════════════════════════
//  extractors/valuation.js — 估值数据提取
//
//  优先源：Artemis 30d 数据，回退 DefiLlama monthly
//  输出：MC, FDV, 30d 手续费/收入及年化值, 4 个估值倍数, 数据源
//
//  合约：缺少 MC 和 FDV 时返回 null；所有计算字段为有效数字或 null。
// ══════════════════════════════════════════════════════

import { safeNum, safeDiv, ANNUALIZE_30D, pick } from './_shared';

/** 数据是否可用（前置过滤，UI / prompt 可不渲染） */
export function isAvailable(project) {
  const mc = safeNum(pick(project, 'cgData.market_data.market_cap.usd'));
  const fdv = safeNum(pick(project, 'cgData.market_data.fully_diluted_valuation.usd'));
  return mc != null || fdv != null;
}

/** 提取完整估值数据；不可用时返回 null */
export function extract(project /* , a */) {
  if (!isAvailable(project)) return null;

  const mc  = safeNum(pick(project, 'cgData.market_data.market_cap.usd'));
  const fdv = safeNum(pick(project, 'cgData.market_data.fully_diluted_valuation.usd'));

  const am = project?.artemisMetrics;
  const artemisOK = !!am?.ok;

  // 优先 Artemis；回退 DefiLlama monthly
  const fees30dArtemis = artemisOK ? safeNum(am.perpFees30d) : null;
  const rev30dArtemis  = artemisOK ? safeNum(am.revenue30d)  : null;
  const fees30dLlama   = safeNum(pick(project, 'defiData.fees.monthly'));
  const rev30dLlama    = safeNum(pick(project, 'defiData.revenue.monthly'));

  const fees30d = fees30dArtemis != null ? fees30dArtemis : fees30dLlama;
  const rev30d  = rev30dArtemis  != null ? rev30dArtemis  : rev30dLlama;

  const feesAnn = fees30d != null ? fees30d * ANNUALIZE_30D : null;
  const revAnn  = rev30d  != null ? rev30d  * ANNUALIZE_30D : null;

  const mcRev   = safeDiv(mc,  revAnn);
  const fdvRev  = safeDiv(fdv, revAnn);
  const mcFees  = safeDiv(mc,  feesAnn);
  const fdvFees = safeDiv(fdv, feesAnn);

  // 数据源 attribution
  let source = 'CoinGecko';
  if (artemisOK && (fees30dArtemis != null || rev30dArtemis != null)) source = 'Artemis';
  else if (fees30dLlama != null || rev30dLlama != null) source = 'DeFiLlama';

  return {
    mc, fdv,
    fees30d, rev30d, feesAnn, revAnn,
    mcRev, fdvRev, mcFees, fdvFees,
    source,
    hasRevenue: revAnn != null && revAnn > 0,
    hasFees:    feesAnn != null && feesAnn > 0,
  };
}
